import styled from 'styled-components';
import Paragraph from '../../Paragraph/Paragraph';
import themeColors from '../../../assets/styles/themeColors';
import { ReactComponent as InfoGttIconSvg } from '../../../assets/images/priceAlerts/info-gtt.svg';
import { ReactComponent as AlertCloseIconSvg } from '../../../assets/images/priceAlerts/alert-close-icon.svg';

import { mediaBelow, pxToRem, pxToRemMd } from '../../../assets/styles/helper';
import { uFlexColumn } from '../../../assets/styles/utility';
import { variables } from '../../../assets/styles/variables';

export const ProductName = styled.h2`
  font-size: 20px;
  font-weight: 500;
  font-family: ${variables.family.goldSilver};
  line-height: 140%;
  color: ${themeColors.colorTextPrimary};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-family: ${variables.family.goldSilver};
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
  }
`;

export const ProductPrice = styled(Paragraph)`
  font-weight: 600;
  font-family: ${variables.family.goldSilver};
  font-size: 20px;
  line-height: 140%;
  color: ${themeColors.colorTextPrimary};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-family: ${variables.family.goldSilver};
    font-weight: 600;
    line-height: 140%;
    font-size: 16px;
    text-align: right;
  }
`;

export const AlertsCountLabel = styled.p`
  margin: 0 0 ${pxToRem(12)};
  font-family: ${variables.family.goldSilver};
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${themeColors.colorTextSecondary};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  gap: ${pxToRem(12)};
`;

export const PrimaryText = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 140%;
  color: ${themeColors.colorTextPrimary};
  margin: 0;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
    font-family: ${variables.family.goldSilver};
  }
`;

export const SecondaryText = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  color: ${themeColors.colorTextSecondary};
  margin: 0;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-family: ${variables.family.goldSilver};
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
  }
`;

export const EmptyStateIcon = styled(InfoGttIconSvg)`
  width: 52px;
  height: 52px;
  margin: 12px;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    width: 35.75px;
    height: 35.75px;
    margin: 8.25px;
  }
`;

export const ProductHeadingRow = styled.div`
  display: flex;
  justify-content: space-between;

  h3 {
    flex: 1;
  }
`;

export const ProductHeadingPrice = styled.div`
  ${uFlexColumn};
  text-align: right;

  svg {
    vertical-align: middle;
    margin-right: 4px;
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(8)};
  height: 32px;
  padding: 0 ${pxToRem(16)};
  border-radius: ${pxToRem(8)};
  background-color: ${themeColors.colorBackgroundSecondary};
  color: ${themeColors.colorTextSecondary};
  font-family: ${variables.family.goldSilver};
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: ${pxToRem(8)};
  border: 1px solid ${themeColors.colorCardBorder};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    gap: 4px;
    width: 100%;
    height: 30px;
    padding: 6px 8px;
    border-radius: 4px;
    font-weight: 400;
  }
`;

export const FullWidthButtonWrapper = styled.div`
  button {
    height: 44px;
  }

  ${mediaBelow(variables.breakpoints.bpMd)} {
    button {
      font-size: 16px;
      font-weight: 600;
      line-height: 100%;
    }
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${themeColors.colorBorderPrimary};
  margin: 0 ${pxToRem(-16)};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    margin: 0 ${pxToRemMd(-16)};
  }
`;

export const UnstyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;

export const ModalCloseIcon = styled(AlertCloseIconSvg)`
  &&& {
    width: 12.5px;
    height: 12.5px;
  }
`;
